/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmissionResultStatus } from './SubmissionResultStatus';
import {
    SubmissionResultStatusFromJSON,
    SubmissionResultStatusFromJSONTyped,
    SubmissionResultStatusToJSON,
    SubmissionResultStatusToJSONTyped,
} from './SubmissionResultStatus';
import type { AcceptedBy } from './AcceptedBy';
import {
    AcceptedByFromJSON,
    AcceptedByFromJSONTyped,
    AcceptedByToJSON,
    AcceptedByToJSONTyped,
} from './AcceptedBy';

/**
 * 
 * @export
 * @interface SubmissionResultRead
 */
export interface SubmissionResultRead {
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultRead
     */
    submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultRead
     */
    test_case_id: string;
    /**
     * 
     * @type {SubmissionResultStatus}
     * @memberof SubmissionResultRead
     */
    status?: SubmissionResultStatus;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultRead
     */
    points?: number | null;
    /**
     * 
     * @type {AcceptedBy}
     * @memberof SubmissionResultRead
     */
    accepted_by?: AcceptedBy | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionResultRead
     */
    near_match?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResultRead
     */
    flagged_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultRead
     */
    flag_comment?: string | null;
}



/**
 * Check if a given object implements the SubmissionResultRead interface.
 */
export function instanceOfSubmissionResultRead(value: object): value is SubmissionResultRead {
    if (!('submission_id' in value) || value['submission_id'] === undefined) return false;
    if (!('test_case_id' in value) || value['test_case_id'] === undefined) return false;
    return true;
}

export function SubmissionResultReadFromJSON(json: any): SubmissionResultRead {
    return SubmissionResultReadFromJSONTyped(json, false);
}

export function SubmissionResultReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionResultRead {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_id': json['submission_id'],
        'test_case_id': json['test_case_id'],
        'status': json['status'] == null ? undefined : SubmissionResultStatusFromJSON(json['status']),
        'points': json['points'] == null ? undefined : json['points'],
        'accepted_by': json['accepted_by'] == null ? undefined : AcceptedByFromJSON(json['accepted_by']),
        'near_match': json['near_match'] == null ? undefined : json['near_match'],
        'flagged_at': json['flagged_at'] == null ? undefined : (new Date(json['flagged_at'])),
        'flag_comment': json['flag_comment'] == null ? undefined : json['flag_comment'],
    };
}

export function SubmissionResultReadToJSON(json: any): SubmissionResultRead {
    return SubmissionResultReadToJSONTyped(json, false);
}

export function SubmissionResultReadToJSONTyped(value?: SubmissionResultRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_id': value['submission_id'],
        'test_case_id': value['test_case_id'],
        'status': SubmissionResultStatusToJSON(value['status']),
        'points': value['points'],
        'accepted_by': AcceptedByToJSON(value['accepted_by']),
        'near_match': value['near_match'],
        'flagged_at': value['flagged_at'] == null ? undefined : ((value['flagged_at'] as any).toISOString()),
        'flag_comment': value['flag_comment'],
    };
}

